export const BudgetDistributionType = ({
    value: {
        label: 'Value',
        key: 'value',
        id: 1,
    },
    percent: {
        label: 'Percent',
        key: 'percent',
        id: 2
    },
})